import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import "./Hero.css";


// 🔗 PLACEHOLDER: Update these details with your own information
const HERO_DATA = {
  greeting: "HELLO, I AM",
  firstName: "M.",
  lastName: "FAHEEM KHAN",
  subtitle: "Digital Product Designer and Animator",
  ctaPrimary: {
    label: "GET STARTED",
    href: "/contact",
  },
  ctaSecondary: {
    label: "LET'S CONNECT",
    href: "https://wa.me/923172642218?text=Hello%20I'm%20interested%20in%20your%20services",
  },
};

// 🔗 Social media links with Font Awesome icons
const SOCIAL_LINKS = [
  {
    name: "Behance",
    icon: "fa-brands fa-behance",
    href: "https://www.behance.net/faheem_graphics",
  },
  {
    name: "Vimeo",
    icon: "fa-brands fa-vimeo-v",
    href: "https://vimeo.com/faheemgrahics",
  },
  {
    name: "LinkedIn",
    icon: "fa-brands fa-linkedin-in",
    href: "https://www.linkedin.com/in/muhammad-faheem-khan-3029541bb/",
  },
  {
    name: "Instagram",
    icon: "fab fa-facebook-f",
    href: "https://www.facebook.com/share/1Dbaf3b7Ri/",
  },
];

export default function Hero() {
  return (
    <section className="hero" id="home">
      {/* Background Banner with proper centering */}
      <div className="hero-banner">
        {/* Desktop banner - shown by default */}
        <img
          src="/images/main banner.jpeg"
          alt="Background"
          className="banner-image desktop-banner"
        />
        {/* Mobile banner - hidden by default, shown below 800px */}
        <img
          src="/images/mobile-banner.jpg"
          alt="Mobile Background"
          className="banner-image mobile-banner"
        />
        <div className="hero-overlay"></div>
      </div>

      <div className="container hero-content">
        <div className="hero-text">
          <p className="hero-greeting">{HERO_DATA.greeting}</p>

          <h1 className="hero-name">
            {HERO_DATA.firstName} {HERO_DATA.lastName}
          </h1>

          <p className="hero-title">{HERO_DATA.subtitle}</p>

          {/* Social Icons with Font Awesome */}
          <div className="hero-social">
            {SOCIAL_LINKS.map((social) => (
              <a
                key={social.name}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                aria-label={social.name}
              >
                <i className={social.icon}></i>
              </a>
            ))}
          </div>

          <div className="hero-cta">
            <a href={HERO_DATA.ctaPrimary.href} className="btn btn-primary">
              {HERO_DATA.ctaPrimary.label}
            </a>
            <a href={HERO_DATA.ctaSecondary.href} className="btn btn-outline">
              {HERO_DATA.ctaSecondary.label}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
